import { memo, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { formatDate } from "../../../common";
import { BranchCode, Gender, genderListSelect, GENDERS_FORMAT, listStatus, roleListSelect, STATUS_USER_COMMON, USER_ROLES, UserStatus } from "../../../constant";
import { useGetAllBranch } from "../../../hooks/query/useGetAllBranch";
import { useGetAllUser } from "../../../hooks/query/useGetAllUser";
import { useUpdateStaff } from "../../../hooks/query/useUpdateStaff";
import { useDebounce } from "../../../hooks/useDebounce";
import InputSelect from "../../InputSelect";
import InputText from "../../InputText";

interface StaffType {
    id: number;
    fullName: string;
    gender: Gender;
    dateOfBirth: string;
    email: string;
    phoneNumber: string;
    address: string;
    roles: string[];
    status: UserStatus;
    staff: {
        id: number;
    }
    branch: {
        code: BranchCode;
        name: string;
    }
}

function Admin() {
    const [name, setName] = useState("");
    const nameDebounce = useDebounce(name, 500);
    const [branch, setBranch] = useState("");
    const [status, setStatus] = useState("");
    const [role, setRole] = useState("");
    const [listBranch, setListBranch] = useState([]);
    const [editingId, setEditingId] = useState<number | null>(null);
    const [editForm, setEditForm] = useState<any>({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data } = useGetAllBranch(1, 10);
    const params = {
        ...(name && { name: nameDebounce }),
        ...(branch && { branch }),
        ...(status && { status }),
        ...(role && { role }),
        userType: "staff",
    };
    const { data: listStaff } = useGetAllUser(params);
    const { mutate: updateStaff, isPending } = useUpdateStaff();

    const formatData = (data: any) => {
        return data?.slice()
            .sort((a: any, b: any) => a.id - b.id)
            .map((branch: any) => {
                return {
                    value: branch.code,
                    label: branch.name
                }
            })
    }

    const handleRowClick = (staff: StaffType) => {
        setEditingId(staff.staff.id);
        setEditForm({
            fullName: staff.fullName,
            gender: staff.gender,
            dateOfBirth: staff.dateOfBirth?.split('T')[0] || "",
            email: staff.email || "",
            phoneNumber: staff.phoneNumber || "",
            address: staff.address || "",
            status: staff.status,
            role: staff.roles[0] || "",
            branch: staff.branch.code || ""
        });
        setIsModalOpen(true);
    };

    const handleInputChange = (field: string, value: any) => {
        setEditForm((prev: any) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleUpdateStaff = () => {
        if (!editingId) return;

        const formData = new FormData();
        formData.append('fullName', editForm.fullName);
        formData.append('gender', editForm.gender);
        formData.append('dateOfBirth', editForm.dateOfBirth);
        formData.append('email', editForm.email);
        formData.append('phoneNumber', editForm.phoneNumber);
        formData.append('address', editForm.address);
        formData.append('status', editForm.status);
        formData.append('role', editForm.role);
        formData.append('branch', editForm.branch);

        updateStaff(
            {
                id: editingId,
                data: formData
            },
            {
                onSuccess: () => {
                    toast.success("Cập nhật dữ liệu nhân viên thành công!");
                    setIsModalOpen(false);
                    setEditingId(null);
                    setEditForm({});
                },
                onError: (error: any) => {
                    console.error("Error updating staff:", error);
                    toast.error("Cập nhật dữ liệu nhân viên thất bại!");
                }
            }
        );
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingId(null);
        setEditForm({});
    };

    useEffect(() => {
        if (data?.data) {
            const result = formatData(data?.data.items);
            setListBranch(result)
        }
    }, [data])

    console.log("listStaff", listStaff?.data);

    const [branchMap, setBranchMap] = useState<Record<string, string>>({});
    useEffect(() => {
        if (data?.data) {
            const items = data.data.items;

            const selectData = formatData(items);
            setListBranch(selectData);

            // tạo map code -> name
            const map = items.reduce((acc: any, item: any) => {
                acc[item.code] = item.name;
                return acc;
            }, {});

            setBranchMap(map);
        }
    }, [data]);

    useEffect(() => {
        if (data?.data) {
            const items = data.data.items;

            const selectData = formatData(items);
            setListBranch(selectData);

            // tạo map code -> name
            const map = items.reduce((acc: any, item: any) => {
                acc[item.code] = item.name;
                return acc;
            }, {});

            setBranchMap(map);
        }
    }, [data]);

    return (<div className="text-white p-[20px] pt-[10px] w-full h-screen">
        <h1 className="font-bold text-[30px] text-center">THÔNG TIN NHÂN VIÊN</h1>
        <div className="mt-[40px]">
            <hr className="my-6" />
            <h2 className="font-bold text-[20px] text-center">Tìm kiếm thông tin nhân viên</h2>
            <div className="w-[30%] mt-[20px]">
                <InputText value={name} onChange={(e) => setName(e.target.value)} label="Tên nhân viên" placeholder="Nhập tên nhân viên..." name="name" inputStyle="text-black" />
                <InputSelect onChange={(e) => setBranch(e.target.value)} value={branch} data={listBranch} name="branch" label="Tên chi nhánh" inputStyle="text-black" />
                <InputSelect onChange={(e) => setStatus(e.target.value)} value={status} data={listStatus} name="branch" label="Tình trạng hoạt động" inputStyle="text-black" />
                <InputSelect onChange={(e) => setRole(e.target.value)} value={role} data={roleListSelect} name="role" label="Chức vụ" inputStyle="text-black" />
            </div>
            <div className="mt-[20px]">
                <hr className="my-6" />
                <h2 className="font-bold text-[20px] text-center mb-[40px]">Danh sách nhân viên</h2>
                {listStaff?.data?.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-gray-800 border border-gray-700 rounded-lg">
                            <thead className="bg-gray-700">
                                <tr>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">ID</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Họ và tên</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Giới tính</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Ngày sinh</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Email</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Số điện thoại</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Địa chỉ</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold min-w-[140px]">Trạng thái</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Chức vụ</th>
                                    <th className="px-4 py-3 text-left text-sm font-semibold">Chi nhánh</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listStaff?.data?.length > 0 && listStaff?.data?.map((staff: StaffType, index: number) => (
                                    <tr
                                        key={staff.id}
                                        onClick={() => handleRowClick(staff)}
                                        className={`border-t border-gray-700 ${index % 2 === 0 ? 'bg-gray-800' : 'bg-gray-750'} hover:bg-gray-600 transition-colors cursor-pointer`}
                                    >
                                        <td className="px-4 py-3 text-sm">{staff.id}</td>
                                        <td className="px-4 py-3 text-sm font-medium">{staff.fullName}</td>
                                        <td className="px-4 py-3 text-sm">{GENDERS_FORMAT[staff.gender]}</td>
                                        <td className="px-4 py-3 text-sm">{formatDate(staff.dateOfBirth)}</td>
                                        <td className="px-4 py-3 text-sm">{staff.email || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">{staff.phoneNumber || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">{staff.address || "Chưa cập nhật"}</td>
                                        <td className="px-4 py-3 text-sm">
                                            <span className={`font-bold px-2 py-1 rounded-full text-xs ${staff.status === 'active' ? 'bg-green-600' : staff.status === 'pending' ? 'bg-yellow-400' : 'bg-red-600'}`}>
                                                {STATUS_USER_COMMON[staff.status]}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                            {USER_ROLES[staff.roles[0] as keyof typeof USER_ROLES] ?? 'Chưa cập nhật'}
                                        </td>
                                        <td className="px-4 py-3 text-sm">{branchMap[staff?.branch?.code] ?? "Chưa cập nhật"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-10 text-gray-400">
                        <p>Không tìm thấy nhân viên nào</p>
                    </div>
                )}
            </div>
        </div>

        {/* Modal chỉnh sửa */}
        {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-gray-800 rounded-lg p-6 w-[600px] max-h-[90vh] overflow-y-auto">
                    <h2 className="text-2xl font-bold mb-4 text-center">Chỉnh sửa thông tin nhân viên</h2>

                    <div className="space-y-4">
                        <InputText
                            label="Họ và tên"
                            value={editForm.fullName}
                            onChange={(e) => handleInputChange('fullName', e.target.value)}
                            name="fullName"
                            inputStyle="text-black"
                        />

                        <InputSelect
                            label="Giới tính"
                            value={editForm.gender}
                            onChange={(e) => handleInputChange('gender', e.target.value)}
                            data={genderListSelect}
                            name="gender"
                            inputStyle="text-black"
                        />

                        <div>
                            <label className="block text-sm font-medium mb-2">Ngày sinh</label>
                            <input
                                type="date"
                                value={editForm.dateOfBirth}
                                onChange={(e) => handleInputChange('dateOfBirth', e.target.value)}
                                className="w-full px-3 py-2 rounded bg-white text-black"
                            />
                        </div>

                        <InputText
                            label="Email"
                            value={editForm.email}
                            onChange={(e) => handleInputChange('email', e.target.value)}
                            name="email"
                            inputStyle="text-black"
                        />

                        <InputText
                            label="Số điện thoại"
                            value={editForm.phoneNumber}
                            onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                            name="phoneNumber"
                            inputStyle="text-black"
                        />

                        <InputText
                            label="Địa chỉ"
                            value={editForm.address}
                            onChange={(e) => handleInputChange('address', e.target.value)}
                            name="address"
                            inputStyle="text-black"
                        />

                        <InputSelect
                            label="Trạng thái"
                            value={editForm.status}
                            onChange={(e) => handleInputChange('status', e.target.value)}
                            data={listStatus}
                            name="status"
                            inputStyle="text-black"
                        />
                        <InputSelect
                            label="Chức vụ"
                            value={editForm.role}
                            onChange={(e) => handleInputChange('role', e.target.value)}
                            data={roleListSelect}
                            name="role"
                            inputStyle="text-black"
                        />
                        {/* <InputText
                            label="Chi nhánh"
                            value={editForm.branch}
                            onChange={(e) => handleInputChange('branch', e.target.value)}
                            name="branch"
                            inputStyle="text-black"
                        /> */}
                        <InputSelect
                            label="Branch"
                            value={editForm.branch}
                            onChange={(e) => handleInputChange('branch', e.target.value)}
                            data={listBranch}
                            name="branch"
                            inputStyle="text-black"
                        />
                    </div>

                    <div className="flex gap-4 mt-6">
                        <button
                            onClick={handleUpdateStaff}
                            disabled={isPending}
                            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed"
                        >
                            {isPending ? "Đang cập nhật..." : "Cập nhật"}
                        </button>
                        <button
                            onClick={handleCloseModal}
                            disabled={isPending}
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                            Hủy
                        </button>
                    </div>
                </div>
            </div>
        )}
    </div>);
}

export default memo(Admin);